// 목양견 규칙 — 서리와 바람 두 마리만 존재한다.
// 구매·입양·임시 합류로 개체 수가 늘어나는 경로는 없다.
import { nightKeyOfCard } from '../gb/config.js';

export const DOG_TREAT_COST = 20;
export const SHEEP_TREAT_COST = 5;
export const DOG_SLOTS_BASE = 2;

const CORE_DOG_IDS = new Set(['seori', 'baram']);

export const dogSlots = () => DOG_SLOTS_BASE;

// 옛 세이브에 추가 개가 남아 있어도 전투 명단에는 절대 들어가지 않는다.
export function fieldDogs(s) {
  return (s.dogs ?? []).filter((d) => CORE_DOG_IDS.has(d.id) && d.injuredDays <= 0);
}

export function nightDogs(s) {
  return fieldDogs(s).map((d) => ({ kind: d.id, role: d.role }));
}

export function treatDog(s, dogId) {
  if (!CORE_DOG_IDS.has(dogId)) return null;
  const d = s.dogs.find((x) => x.id === dogId);
  if (!d || d.injuredDays <= 0) return null;
  const cost = s.day.event === 'herbs' ? Math.round(DOG_TREAT_COST / 2) : DOG_TREAT_COST;
  if (s.ledger.cheese < cost) return { ok: false, why: 'poor', cost };
  s.ledger.cheese -= cost;
  s.ledger.spendLog.push({ day: s.journey.dayNo, kind: 'dogTreat', cost });
  d.injuredDays--;
  const sc = s.scars.find((x) => x.id === '부상(개)' && x.targetId === d.id);
  if (sc) {
    sc.daysLeft--;
    if (sc.daysLeft <= 0) s.scars = s.scars.filter((x) => x !== sc);
  }
  return { ok: true, cost, left: d.injuredDays };
}

// 양 부상은 현재 발생 경로가 없어 치료 대상도 없다.
export function treatSheep() {
  return { ok: false, why: '부상한 양을 만들지 않는 설계라 대상이 생기지 않는다' };
}

// 사자 밤 직전에는 두 고정 목양견의 부상만 회복한다.
export function forceHealForLionNight(s, nightNo) {
  if ('N' + nightNo !== nightKeyOfCard('N30')) return false;
  let healed = 0;
  for (const d of s.dogs) {
    if (CORE_DOG_IDS.has(d.id) && d.injuredDays > 0) {
      d.injuredDays = 0;
      healed++;
    }
  }
  s.scars = s.scars.filter((x) => x.id !== '부상(개)');
  if (healed) s.day.cues.push({ c: 'dogs-know', n: healed });
  return healed > 0;
}
